// import { derived } from 'overmind';
import { merge, namespaced } from 'overmind/config';

import * as config from '@/common/overmind/namespaces/arcgis/config';
import * as identity from '@/common/overmind/namespaces/arcgis/identity';
import * as token from '@/common/overmind/namespaces/arcgis/token';
import * as featureSearch from '@/features/build-calculation-context/overmind/namespaces/arcgis/featureSearch';
import * as featureTypes from '@/features/build-calculation-context/overmind/namespaces/arcgis/featureTypes';
import * as featuresInBounds from '@/features/build-calculation-context/overmind/namespaces/arcgis/featuresInBounds';
import * as featureServer from '@/features/build-calculation-context/overmind/namespaces/arcgis/featureserver';
import * as mapImage from '@/features/build-calculation-context/overmind/namespaces/arcgis/mapImage';
import * as featureGeometries from '@/features/execute-calculation-set/overmind/arcgis/featureGeometries';

import * as actions from './actions';
import * as auth from './auth';

const childStates = namespaced({
  token,
  identity,
  featureServer,
  config,
  featureTypes,
  mapImage,
  featuresInBounds,
  featureGeometries,
  featureSearch,
  auth
});

export const arcgis = merge(childStates, { actions });
